'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RailLogoNumber(props) {
  var components = props.components;

  var styleFlightNumberLabel = (0, _emailStyleTools.textStyles)(components, 'FlightNumberLabel');
  var carrierCode = props.carrierCode,
      carrierName = props.carrierName;


  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'FlightLogoNumber' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0', textAlign: 'center' } },
          _react2.default.createElement('img', { src: 'https://goprivate.wspan.com/Scripts/us/GNG/ImagesGNG/rail.png', alt: 'logo', style: { width: '50px', height: '50px' } })
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0', textAlign: 'center' } },
          _react2.default.createElement(
            'span',
            { style: styleFlightNumberLabel },
            carrierName + '(' + carrierCode + ')'
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(RailLogoNumber);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/RailCard/Email/RailLogoCarrierNumber.jsx
// module id = 1553
// module chunks = 0